import { useAuth } from "../auth/useAuth";
import "./PricingSection.css";
import { useState, useEffect} from "react";
import { useLocation, useNavigate } from "react-router-dom"; 
import Loader from "../components/loader";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import {
  FaBrain, FaComments, FaTasks, FaCheck, FaDownload, FaListAlt,
  FaChartBar, FaIdBadge, FaClipboardCheck, FaStar, FaCrown,
  FaCommentDots, FaChartPie, FaFileAlt,
} from "react-icons/fa";

// Backend base URL
const BACKEND_BASE_URL =
  process.env.REACT_APP_BACKEND_URL || "https://backend-ewrn.onrender.com";
// Plan amounts
const PLAN_AMOUNTS = {
  Pro: 199,
  Premium: 299,
};
const isMobileDevice = () =>
  window.matchMedia("(max-width: 768px)").matches;


// Load Razorpay script
const loadRazorpayScript = () => {
  return new Promise((resolve) => {
    if (window.Razorpay) {
      resolve(true);
      return;
    }
    const script = document.createElement("script");
    script.src = "https://checkout.razorpay.com/v1/checkout.js";
    script.async = true;
    script.onload = () => resolve(true);
    script.onerror = () => resolve(false);
    document.body.appendChild(script);
  });
};

export default function PricingSection({setToggle, onClose}) {
  const { user } = useAuth();
  const { state } = useLocation();
  const navigate = useNavigate();
  

  const [activePlan, setActivePlan] = useState(null);
  const [contactNum, setContactNum] = useState(null);
  const [loading, setLoading] = useState(false);

const getRandom = (min, max) =>
  Math.floor(Math.random() * (max - min + 1)) + min;

const [animatedDigits, setAnimatedDigits] = useState(() => ({
  Pro: [
    0,
    getRandom(2, 6), // 2nd digit: 2–6
    getRandom(2, 7), // 3rd digit: 2–7
  ],
  Premium: [
    0,
    getRandom(2, 6),
    getRandom(2, 7),
  ],
}));


  // 🔑 Report info
  let reportId = localStorage.getItem("payingReportId")
  let reportType = localStorage.getItem("payingReportType")
  const mindReports=localStorage.getItem("mindReports")

  let reportsPath="reports"

  let mailPath='idea-validation'
  if(mindReports){
    mailPath="api/mind-mapping"
    reportId=localStorage.getItem("mindpayingReportId");
    reportsPath="mind-mapping/reports"
    reportType=localStorage.getItem("mindpayingReportType");
  }
  // 🚨 Safety redirect
  useEffect(() => {
    if ((!reportId || !reportType)) {
      console.warn("Missing report details, redirecting...");
      navigate(`/${reportsPath}`);
    }
  }, [reportId, reportType, navigate, reportsPath]);
  // Set active plan
useEffect(() => {
  if (localStorage.getItem("proButtonActive") === "true") setActivePlan("Pro");
  else if (localStorage.getItem("premiumButtonActive") === "true") setActivePlan("Premium");
  else if (localStorage.getItem("mindproButtonActive") === "true") setActivePlan("Pro");
  else if (localStorage.getItem("mindpremiumButtonActive") === "true") setActivePlan("Premium");
  else setActivePlan(null);
}, []);

useEffect(() => {
  if (!activePlan) return;

  const target =
    activePlan === "Pro" ? [1, 9, 9] : [2, 9, 9];

  let current = [...animatedDigits[activePlan]];


  const interval = setInterval(() => {
    current = current.map((digit, i) => {
      if (digit < target[i]) return digit + 1;
      return digit;
    });

    setAnimatedDigits((prev) => ({
      ...prev,
      [activePlan]: [...current],
    }));

    if (
      current[0] === target[0] &&
      current[1] === target[1] &&
      current[2] === target[2]
    ) {
      clearInterval(interval);
    }
  }, 80); // smooth & premium

  return () => clearInterval(interval);
}, [activePlan,animatedDigits]);




  // 🔥 Fetch contact number
  useEffect(() => {
    setContactNum(state?.report?.contact || user?.mobile || null);
  }, [state, user]);

  // 🔥 Toast helper with NAVIGATION Logic
// 🔥 Toast helper with NAVIGATION Logic
  const showToast = (message, type = "info") => {
    const options = {
      className: "orange-toast",
      autoClose: 2000,
      onClose: () => {
        // ✅ Cleanup & Redirect only on SUCCESS
        if (type === "success") {
            localStorage.removeItem("proButtonActive");
            localStorage.removeItem("premiumButtonActive");
            localStorage.removeItem("payingReportId");
            localStorage.removeItem("payingReportType");
            localStorage.removeItem("mindproButtonActive");
            localStorage.removeItem("mindpremiumButtonActive");
            localStorage.removeItem("mindpayingReportId");
            localStorage.removeItem("mindpayingReportType");
            
            // Fixed Navigation Logic
            const isMobile = isMobileDevice();

            if (isMobile) {
              // 📱 MOBILE → always go to combined mobile reports
              localStorage.removeItem("mindReports");
              navigate(`/mobile/reports`);
            } else {
              // 🖥️ DESKTOP → split by report type
              if (mindReports) {
                localStorage.removeItem("mindReports");
                navigate(`/mind-mapping/reports`);
              } else {
                navigate(`/reports`);
              }
            }

        }
      },
    };

    if (type === "success") toast.success(message, options);
    else if (type === "error") toast.error(message, options);
    else toast.info(message, options);
  };
  // 🟢 Helper to send report (ONLY ONE DEFINITION NOW)
const sendSelectedReport = async (targetReportId, targetUserId,invoiceData) => {
  if (!targetReportId || !targetUserId) {
    console.error("Missing ID for sending report:", { targetReportId, targetUserId });
    showToast("Error: Missing User or Report ID.", "error");
    return;
  }

  try {
    setLoading(true);

    const response = await fetch(
      `${BACKEND_BASE_URL}/${mailPath}/send-latest-report`,
      {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        credentials: "include",
        body: JSON.stringify({
          userId: targetUserId,
          reportId: targetReportId,
          reportType: reportType,
          invoiceData: invoiceData, // ✅ add invoice data for email context
        }),
      }
    );

    const data = await response.json();

    if (response.ok) {
      showToast(
        "Payment Success! Report sent to your email successfully!",
        "success"
      );
    } else {
      console.warn("Report send failed:", data?.message);
      showToast(
        "Payment Success! (Report email pending)",
        "success"
      );
    }
  } catch (err) {
    console.error("Send report error:", err);

    // 💡 IMPORTANT: payment already succeeded
    showToast(
      "Payment Success! (Server error sending email)",
      "success"
    );
  } finally {
    setLoading(false);
  }
};


  // 💳 Razorpay payment
  const startReportPayment = async (plan) => {
      setToggle(false)
       onClose()
    if (!user || !user.user_id) {
      toast.error("User not authenticated. Please login again.");
      return;
    }

    try {
      const loaded = await loadRazorpayScript();
      if (!loaded) {
        toast.error("Failed to load Razorpay SDK.");
        return;
      }

      const amountInPaise = PLAN_AMOUNTS[plan] * 100;
      const name = user?.name || "Guest User";
      const email = user?.email || "void@example.com";
      const contact = contactNum || user?.contact || "9999999999"; 

      const createRes = await fetch(
        `${BACKEND_BASE_URL}/reportpayment/create-order`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          credentials: "include",
          body: JSON.stringify({
            amount: amountInPaise,
            plan:activePlan,
            currency: "INR",
            customer: { name, email, contact },
          }),
        }
      );

      const createData = await createRes.json();
      if (!createRes.ok || !createData.success) {
        showToast(createData.message || "Unable to create order.", "error");
        return;
      }

      const { order_id, key_id, amount, currency } = createData;

      const options = {
        key: key_id,
        amount,
        currency,
        name: "MARSMATE AI",
        description: `${plan} Validation Report`,
        image: "https://i.postimg.cc/mr6Mdf1P/Payment-logo-(1).png",
        order_id,
        prefill: { name, email, contact },
        theme: { color: plan === "Premium" ? "#ffd700" : "#c0c0c0" },

        handler: async (response) => {
          try {
            const verifyRes = await fetch(
              `${BACKEND_BASE_URL}/reportpayment/verify`,
              {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                credentials: "include",
                body: JSON.stringify({
                razorpay_order_id: response.razorpay_order_id,
                razorpay_payment_id: response.razorpay_payment_id,
                razorpay_signature: response.razorpay_signature,
                reportId,
                reportType,
                plan: activePlan, // ✅ add
                customer_name: name, // ✅ add
                customer_email: email, // ✅ add
                customer_contact: contact, // ✅ add
                mindReports,
              }),
              }
            );

            const verifyData = await verifyRes.json();

            if (!verifyRes.ok || !verifyData.success) {
              showToast(verifyData?.message || "Verification failed", "error");
              return;
            }

            // ✅ Success! Now trigger report send (which handles navigation)
            await sendSelectedReport(reportId, user.user_id,verifyData.invoice_id);

          } catch (err) {
            console.error("Verification error:", err);
            showToast("Payment verification failed.", "error");
          }
        },

        modal: {
          ondismiss: () => toast.info("Payment was cancelled."),
        },
      };

      const rzp = new window.Razorpay(options);
      rzp.open();

    } catch (err) {
      console.error("Payment error:", err);
      toast.error("Unable to start payment.");
    }
  };

  const handleProClick = () => startReportPayment("Pro");
  const handlePremiumClick = () => startReportPayment("Premium");

  // Icons mapper
  const getFeatureIcon = (text) => {
    const t = text.toLowerCase();
    if (t.includes("exclusive feedback")) return <FaCommentDots className="subscription-icon" />;
    if (t.includes("section score")) return <FaChartPie className="subscription-icon" />;
    if (t.includes("executive summary")) return <FaFileAlt className="subscription-icon" />;
    if (t.includes("score")) return <FaChartBar className="subscription-icon" />;
    if (t.includes("summary")) return <FaListAlt className="subscription-icon" />;
    if (t.includes("feedback")) return <FaComments className="subscription-icon" />;
    if (t.includes("customized")) return <FaTasks className="subscription-icon" />;
    if (t.includes("remarks")) return <FaClipboardCheck className="subscription-icon" />;
    if (t.includes("lacking")) return <FaBrain className="subscription-icon" />;
    if (t.includes("grades")) return <FaStar className="subscription-icon" />;
    if (t.includes("id")) return <FaIdBadge className="subscription-icon" />;
    if (t.includes("download")) return <FaDownload className="subscription-icon" />;
    return <FaCheck className="subscription-icon" />;
  };

  const getCrownColor = (title) => {
    if (title === "Pro") return "#c0c0c0";
    if (title === "Premium") return "#ffd700";
    return "#000";
  };

  const plans = [
    {
      title: "Pro",
      price: "199",
      subtitle: "Full Report Card",
      features: [
        "Your Score", "Your Validation Report", "Customized Plans",
        "Remarks & Recommended Actions", "Splitting and showing where you are lacking", "Download Feature",
      ],
      onClick: handleProClick,
      disabled: activePlan === "Premium",
    },
    {
      title: "Premium",
      price: "299",
      subtitle: "Advanced Report Card",
      features: [
        "Your Score", "Exclusive Feedback Based on Score", "Specific Section Score and Their Grades with Key Observations",
        "Special Executive Summary Based on Score", "Customized Plans", "Downloadable Option",
      ],
      onClick: handlePremiumClick,
      disabled: activePlan === "Pro",
    },
  ];

  // Prevent UI flash until token is generated
  

 return (
  <div className="subscription-wrapper">
    {loading ? (
      <Loader text="Please wait, we are sending your report to your email..." />
    ) : (
      <>
        <h2 className="subscription-heading">Upgrade your plan</h2>

        <div className="subscription-cards">
          {plans.map((plan, index) => (
            <div
              key={index}
              className={`subscription-card ${plan.title.toLowerCase()}`}
            >
              <div className="subscription-title-row">
                <h3 className="subscription-title">{plan.title}</h3>
                <FaCrown
                  className="subscription-crown"
                  style={{ color: getCrownColor(plan.title) }}
                />
              </div>

              <div className="subscription-price-box">
                <span className="subscription-price">
                  ₹
                  {(activePlan === plan.title
                    ? animatedDigits[plan.title]
                    : plan.price.split("").map(Number)
                  ).map((digit, index) => (
                    <span key={index} className="digit-container-pricing">
                      <span
                        className="digit-strip-pricing"
                        style={{ transform: `translateY(-${digit * 48}px)` }}
                      >
                        {[...Array(10)].map((_, n) => (
                          <span key={n} className="digit-pricing">
                            {n}
                          </span>
                        ))}
                      </span>
                    </span>
                  ))}
                </span>
              </div>

              <p className="subscription-subtitle">{plan.subtitle}</p>

              <button
                className={`subscription-btn ${
                  plan.disabled ? "disabled-btn" : ""
                }`}
                onClick={plan.onClick}
                disabled={plan.disabled}
              >
                Get {plan.title}
              </button>

              <ul className="subscription-features">
                {plan.features.map((f, i) => (
                  <li key={i} className="subscription-feature-item">
                    {getFeatureIcon(f)}
                    <span>{f}</span>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </>
    )}

    {/* ✅ ALWAYS MOUNTED */}
    <ToastContainer
      position="top-right"
      autoClose={2000}
      hideProgressBar={false}
      newestOnTop
      closeOnClick
      pauseOnHover
      draggable
    />
  </div>
);

}